import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { IMAGES } from 'src/app/constants/imagePath';
import { ROUTES } from 'src/app/constants/Routes';
import { CareerService } from 'src/app/service/career.service';

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss'],
  standalone: false
})
export class CareersComponent implements OnInit {
  Routes = ROUTES;
  Images = IMAGES;

  activeTab: 'openings' | 'future' = 'openings';

  futureFormData = {
    first_name: '',
    last_name: '',
    emailId: '',
    phone: '',
    role: '',
    message: ''
  };
  futureAttachment: File | null = null;
  futureFormSuccess = false;
  futureFormError = false;
  futureFormLoading = false;

  jobs = [
    {
      title: "Android Developer",
      experience: "5-7 years",
      location: "Pune, Maharashtra",
      employmentType: "Full Time",
      status: "Currently Not Hiring",
      description: "We are hiring an Android Developer to create high-quality mobile applications, ensuring performance and responsiveness.",
      route: this.Routes.android_jd,
    },
    {
      title: "Project Manager (IT)",
      experience: "6-9 years",
      location: "Pune, Maharashtra",
      employmentType: "Full Time",
      status: "Currently Not Hiring",
      description: "The Project Manager leads projects, ensuring timely delivery with Agile methods, managing teams, risks, and stakeholders.",
      route: this.Routes.projectmanager_jd,
    },
    {
      title: "Product Manager",
      experience: "5-7 years",
      location: "Pune, Maharashtra",
      employmentType: "Full Time",
      status: "Currently Not Hiring",
      description: "The Product Manager shapes product vision, manages its lifecycle, and collaborates with teams to deliver quality solutions.",
      route: this.Routes.productmanager_jd,
    },
    {
      title: "iOS Developer",
      experience: "5-7 years",
      location: "Pune, Maharashtra",
      employmentType: "Full Time",
      status: "Currently Not Hiring",
      description: "Looking for an iOS Developer to build cutting-edge mobile applications tailored for Apple's ecosystem.",
      route: this.Routes.ios_jd,
    },
    {
      title: "DevOps Engineer",
      experience: "5-7 years",
      location: "Pune, Maharashtra",
      employmentType: "Full Time",
      status: "Currently Not Hiring",
      description: "We are looking for a DevOps Engineer with expertise in cloud solutions, CI/CD pipelines, and monitoring tools to support deployment and infrastructure.",
      route: this.Routes.devops_jd,
    },
    {
      title: "Java Developer",
      experience: "5-7 years",
      location: "Pune, Maharashtra",
      employmentType: "Full Time",
      status: "Currently Not Hiring",
      description: "A seasoned Java Developer is required to design, develop, and maintain high-performance, scalable, and secure Java applications.",
      route: this.Routes.java_jd,
    },
    {
      title: "Jr. QA Engineer",
      experience: "2+ years",
      location: "Pune, Maharashtra",
      employmentType: "Full Time",
      status: "Currently Not Hiring",
      description: "We need a Junior QA Engineer to test, debug, and ensure the quality of software applications while adhering to industry standards.",
      route: this.Routes.jr_qa_jd,
    }
  ];

  get openJobs() {
    return this.jobs.filter(j => !j.status);
  }

  get futureRoles(): string[] {
    return this.jobs.map(j => j.title);
  }

  setTab(tab: 'openings' | 'future') {
    this.activeTab = tab;
  }

  onFutureFileChange(event: any) {
    this.futureAttachment = event.target.files[0] || null;
  }

  onFutureSubmit(form: NgForm) {
    if (form.valid && this.futureAttachment) {
      this.futureFormLoading = true;
      this.futureFormError = false;
      const subject = `[FUTURE] ${this.futureFormData.role} : ${this.futureFormData.first_name} ${this.futureFormData.last_name}`;
      const message =
        `Name: ${this.futureFormData.first_name} ${this.futureFormData.last_name}\n` +
        `Email: ${this.futureFormData.emailId}\n` +
        `Phone: ${this.futureFormData.phone}\n` +
        `Role Interested In: ${this.futureFormData.role}\n\n` +
        `About: ${this.futureFormData.message}`;
      this.careerService.sendFormData(this.futureFormData.emailId, message, subject, this.futureAttachment)
        .subscribe({
          next: () => { this.futureFormSuccess = true; this.futureFormLoading = false; },
          error: () => { this.futureFormError = true; this.futureFormLoading = false; }
        });
    } else if (!this.futureAttachment) {
      this.futureFormError = true;
    }
  }

  constructor(private careerService: CareerService) { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

}
